import template from './downlist-modal.html'
import controller from './downlist-modal.controller'
import './downlist-modal.scss'

let downlistComponent = {
  template,
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  },
  controller
}

export default downlistComponent


// WEBPACK FOOTER //
// ./src/app/common/downlist-modal/downlist-modal.component.js